import { words, isEmpty, groupBy } from "lodash";
import moment from "moment";

export const getCountByCity = (zipCodes, cities) => {
  const parseData = cities.map(city => words(city));
  const formatData = parseData.map((city, index) => {
    const count = zipCodes.find(zip => city[1] === zip.zipCode);
    return {
      key: index,
      city: city[0],
      zipCode: city[1],
      count: count.count,
    };
  });

  const finalData = formatData.reduce((acc, cur, index) => {
    if (acc.findIndex(obj => obj.city === cur.city) === -1) {
      acc.push({
        city: cur.city,
        count: cur.count,
        key: cur.key,
      });
    } else {
      const currentCount =
        acc[acc.findIndex(obj => obj.city === cur.city)].count;
      acc.splice(
        acc.findIndex(obj => obj.city === cur.city),
        1
      );
      acc.push({
        city: cur.city,
        count: cur.count + currentCount,
        key: cur.key,
      });
    }
    return acc;
  }, []);

  return finalData;
};

export const getVisitsByDayOfWeek = data => {
  return isEmpty(data)
    ? []
    : [
        {
          type: "First Visits",
          Sun:
            data.findIndex(day => day.DAY === "Sunday") !== -1
              ? data[data.findIndex(day => day.DAY === "Sunday")].UNIQUE
              : 0,
          Mon:
            data.findIndex(day => day.DAY === "Monday") !== -1
              ? data[data.findIndex(day => day.DAY === "Monday")].UNIQUE
              : 0,
          Tues:
            data.findIndex(day => day.DAY === "Tuesday") !== -1
              ? data[data.findIndex(day => day.DAY === "Tuesday")].UNIQUE
              : 0,
          Wed:
            data.findIndex(day => day.DAY === "Wednesday") !== -1
              ? data[data.findIndex(day => day.DAY === "Wednesday")].UNIQUE
              : 0,
          Thurs:
            data.findIndex(day => day.DAY === "Thursday") !== -1
              ? data[data.findIndex(day => day.DAY === "Thursday")].UNIQUE
              : 0,
          Fri:
            data.findIndex(day => day.DAY === "Friday") !== -1
              ? data[data.findIndex(day => day.DAY === "Friday")].UNIQUE
              : 0,
          Sat:
            data.findIndex(day => day.DAY === "Saturday") !== -1
              ? data[data.findIndex(day => day.DAY === "Saturday")].UNIQUE
              : 0,
        },
        {
          type: "Returning Visits",
          Sun:
            data.findIndex(day => day.DAY === "Sunday") !== -1
              ? data[data.findIndex(day => day.DAY === "Sunday")].REPEAT
              : 0,
          Mon:
            data.findIndex(day => day.DAY === "Monday") !== -1
              ? data[data.findIndex(day => day.DAY === "Monday")].REPEAT
              : 0,
          Tues:
            data.findIndex(day => day.DAY === "Tuesday") !== -1
              ? data[data.findIndex(day => day.DAY === "Tuesday")].REPEAT
              : 0,
          Wed:
            data.findIndex(day => day.DAY === "Wednesday") !== -1
              ? data[data.findIndex(day => day.DAY === "Wednesday")].REPEAT
              : 0,
          Thurs:
            data.findIndex(day => day.DAY === "Thursday") !== -1
              ? data[data.findIndex(day => day.DAY === "Thursday")].REPEAT
              : 0,
          Fri:
            data.findIndex(day => day.DAY === "Friday") !== -1
              ? data[data.findIndex(day => day.DAY === "Friday")].REPEAT
              : 0,
          Sat:
            data.findIndex(day => day.DAY === "Saturday") !== -1
              ? data[data.findIndex(day => day.DAY === "Saturday")].REPEAT
              : 0,
        },
      ];
};

export const getTotalConversions = data => {
  const parsedData = data.map(con => {
    return con.CONVERSIONS;
  });
  const count = isEmpty(data)
    ? 0
    : parsedData.reduce((acc, cur) => {
        return acc + cur;
      });
  return count;
};

export const getWalkInCountByLocation = data => {
  const countByLocation = data.reduce((acc, cur, ind) => {
    const address = `${cur.ADDRESS}`;
    if (isEmpty(acc)) {
      acc.push({
        location: address,
        lat: cur.LAT,
        lng: cur.LNG,
        count: 0,
        key: ind,
      });
    }
    if (!isEmpty(acc)) {
      const index = acc.findIndex(loc => loc.location === address);
      if (index !== -1) {
        const amount = acc[index].count;
        acc.splice(index, 1, {
          location: address,
          lat: cur.LAT,
          lng: cur.LNG,
          count: amount + cur.COUNT,
          key: ind,
        });
      } else {
        acc.push({
          location: address,
          lat: cur.LAT,
          lng: cur.LNG,
          count: cur.COUNT,
          key: ind,
        });
      }
    }
    return acc;
  }, []);
  return countByLocation;
};

export const getCampaignNames = data => {
  const campaigns = data;
  let campaignNames = [];
  campaigns.campaigns.forEach((campaign, index) => {
    if (
      campaign.reports.findIndex(report => report.type === "ATTRIBUTION") !== -1
    ) {
      campaignNames.push({
        campaignName: campaign.name,
        report:
          campaign.reports[
            campaign.reports.findIndex(report => report.type === "ATTRIBUTION")
          ],
        key: index,
      });
    }
  });
  return campaignNames;
};

export const parseCampaignData = campaign => {
  const data = isEmpty(campaign)
    ? {}
    : campaign.placements[0].aggregateData.aggData;
  const otherData = isEmpty(campaign) ? [] : campaign;
  return {
    aggImpressions: isEmpty(data) ? null : data.aggImpressions,
    end: isEmpty(otherData) ? null : otherData.endDate,
    start: isEmpty(otherData) ? null : otherData.startDate,
  };
};

export const calculateResponseRate = (devicesServed, visits) => {
  const percentage = (visits / devicesServed) * 100;
  return Number(percentage).toFixed(3);
};

export const cumulativeResponseData = data =>
  data
    .sort((a, b) => {
      if (a.CONVERSIONDATE === b.CONVERSIONDATE) return 0;
      if (moment(a.CONVERSIONDATE).isAfter(b.CONVERSIONDATE)) return 1;
      return -1;
    })
    .reduce(
      ([cumulativeCount, entries], curr) => {
        let nextCumulativeCount = cumulativeCount + curr.COUNT;
        let nextCumulativeUnique = cumulativeCount + curr.UNIQUE;
        entries.push({
          day: curr.CONVERSIONDATE,
          count: nextCumulativeCount,
          unique: nextCumulativeUnique,
          xAxis: moment(curr.CONVERSIONDATE).format(),
        });
        return [nextCumulativeCount, entries];
      },
      [0, []]
    )[1];

const getDaysArray = (s, e) => {
  for (var a = [], d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
    a.push(moment(d).format("YYYY-MM-DD"));
  }
  return a;
};

export const walkinResponseDataByDate = data => {
  const sortedData = data.sort((a, b) => {
    if (a.CONVERSIONDATE === b.CONVERSIONDATE) return 0;
    if (moment(a.CONVERSIONDATE).isAfter(b.CONVERSIONDATE)) return 1;
    return -1;
  });

  const startDate = sortedData[0].CONVERSIONDATE;
  const endDate = sortedData[sortedData.length - 1].CONVERSIONDATE;

  const dates = getDaysArray(new Date(startDate), new Date(endDate));

  return dates.map(date => {
    return {
      count: sortedData.filter(sorted => sorted.CONVERSIONDATE === date).length
        ? sortedData.filter(sorted => sorted.CONVERSIONDATE === date)[0].COUNT
        : 0,
      unique: sortedData.filter(sorted => sorted.CONVERSIONDATE === date).length
        ? sortedData.filter(sorted => sorted.CONVERSIONDATE === date)[0].UNIQUE
        : 0,
      xAxis: moment(date).format(),
    };
  });
};

export const getStartAndEndDates = data => {
  let dates = [];
  data.forEach(date => {
    if (date.xAxis !== null) {
      dates.push(moment(date.xAxis));
    }
  });
  const start = moment.min(dates);
  const end = moment.max(dates);
  return {
    start: start,
    end: end,
  };
};

export const repeatWalkInsByLocation = (locations, duplicateIds) => {
  const repeatWalkIns = locations.map(location => {
    let repeats = 0;
    duplicateIds.forEach(el => {
      if (el.length > 1) {
        const repeatVisits = groupBy(el, loc => loc.ADDRESS);
        if (repeatVisits[location.ADDRESS])
          if (repeatVisits[location.ADDRESS].length > 1)
            repeats = repeats + repeatVisits[location.ADDRESS].length;
      }
    });
    return {
      ...location,
      REPEATWALKINS: repeats,
    };
  });
  return repeatWalkIns;
};

export const completeWalkInsByCreative = (locations, creativeData) => {
  const repeatWalkIns = locations.map(location => {
    const creativeImpressions = creativeData.find(
      creative => location.CREATIVE_ID === creative.value
    )
      ? creativeData.find(creative => location.CREATIVE_ID === creative.value)
      : location.COUNT;
    return {
      ...location,
      IMPRESSIONS: creativeImpressions.impressions
        ? creativeImpressions.impressions
        : creativeImpressions,
    };
  });
  return repeatWalkIns;
};

export const walkInByDateWithUnique = (data, duplicates) => {
  const repeatWalkIns = data.map(date => {
    let repeats = 0;
    duplicates.forEach(el => {
      if (el.length > 1) {
        const repeatVisits = groupBy(el, day => day.CONVERSION_DATE);
        if (repeatVisits[date.CONVERSIONDATE])
          if (repeatVisits[date.CONVERSIONDATE].length > 1)
            repeats = repeats + repeatVisits[date.CONVERSIONDATE].length;
      }
    });
    return {
      ...date,
      UNIQUE: date.COUNT - repeats,
    };
  });
  return repeatWalkIns;
};

export const getWalkinByLineItem = (attributionData, campaignData) => {
  const lineItemMap = {};
  if (campaignData.campaigns) {
    // If viewing a campaign order need to aggregate across campaigns
    campaignData.campaigns.forEach(campaign =>
      campaign.lineItems.forEach(lineItem => {
        if (!lineItemMap[lineItem.id]) lineItemMap[lineItem.id] = lineItem;
      })
    );

    const attributionWithLineItems = attributionData.map(lineItem => {
      let numOfImpressions = 0;
      campaignData.campaigns.forEach(campaign => {
        const lineItemMatch = campaign.lineItems.find(
          el => el.adProviderId === lineItem.CAMPAIGN_ID
        );
        if (
          lineItemMatch &&
          lineItemMatch.aggregateData &&
          lineItemMatch.aggregateData.overallData
        ) {
          numOfImpressions +=
            lineItemMatch.aggregateData.overallData.aggImpressions;

          delete lineItemMap[lineItemMatch.id];
        }
      });
      return {
        ...lineItem,
        IMPRESSIONS: numOfImpressions,
      };
    });
    const lineItemsWithoutAttribution = Object.values(lineItemMap).map(
      lineItem => {
        return {
          COUNT: 0,
          CAMPAIGN_ID: lineItem.id,
          CAMPAIGN_NAME: lineItem.name,
          UNIQUE: 0,
          IMPRESSIONS: lineItem.aggregateData
            ? lineItem.aggregateData.overallData.aggImpressions
            : 0,
        };
      }
    );
    return [...attributionWithLineItems, ...lineItemsWithoutAttribution];
  } else {
    campaignData.lineItems.forEach(
      lineItem => (lineItemMap[lineItem.id] = lineItem)
    );
    const attributionWithLineItems = attributionData.map(lineItem => {
      const lineItemMatch = campaignData.lineItems.find(
        el => el.adProviderId === lineItem.CAMPAIGN_ID
      );
      if (lineItemMatch) delete lineItemMap[lineItemMatch.id];
      return {
        ...lineItem,
        IMPRESSIONS:
          lineItemMatch &&
          lineItemMatch.aggregateData &&
          lineItemMatch.aggregateData.overallData
            ? lineItemMatch.aggregateData.overallData.aggImpressions
            : 0,
      };
    });
    const lineItemsWithoutAttribution = Object.values(lineItemMap).map(
      lineItem => {
        return {
          COUNT: 0,
          CAMPAIGN_ID: lineItem.id,
          CAMPAIGN_NAME: lineItem.value,
          UNIQUE: 0,
          IMPRESSIONS: lineItem.impressions,
        };
      }
    );
    return [...attributionWithLineItems, ...lineItemsWithoutAttribution];
  }
};

export const mergeDiplayToAttributionCreatives = (
  attributionData,
  displayData
) => {
  const creativeMap = {};

  if (isEmpty(displayData)) return [];

  displayData.forEach(creative => (creativeMap[creative.id] = creative));
  const mergedAttributionData = attributionData.map(row => {
    const displayMatch = creativeMap[row.CREATIVE_ID];
    if (displayMatch) delete creativeMap[row.CREATIVE_ID];
    return {
      ...row,
      PROVIDER_CREATIVE_NAME: displayMatch
        ? displayMatch.value
        : row.PROVIDER_CREATIVE_NAME,
      IMPRESSIONS: displayMatch ? displayMatch.impressions : 0,
    };
  });
  const creativesWithoutAttribution = Object.values(creativeMap).map(
    creative => {
      return {
        COUNT: 0,
        CREATIVE_ID: creative.id,
        PROVIDER_CREATIVE_NAME: creative.value,
        UNIQUE: 0,
        IMPRESSIONS: creative.impressions,
      };
    }
  );
  return [...mergedAttributionData, ...creativesWithoutAttribution];
};
